/* eslint no-unused-vars:0 */
import React, { Component } from 'react'

export class Graceful extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  componentDidCatch(error, info) {
    this.setState({ error })
  }

  render() {
    if (this.state.error) {
      return null
    }

    return this.props.children
  }
}
